import { CanView } from "components/Common/CanView"
import StockPricingUpdate from "pages/StockPages/StockView/StockPricingUpdate"
import { ACCESS } from "constants/accessPermissions"
import { formatBDT } from "utils/formatPrice"

const StockPriceCell = ({ stock }) => {
  const youSave =
    stock?.asking_price && stock?.discount_price
      ? stock.asking_price - stock.discount_price
      : 0

  const youSavePercent =
    stock?.asking_price && stock?.discount_price
      ? Math.round(
          ((stock.asking_price - stock.discount_price) / stock.asking_price) *
            100
        )
      : 0

  return (
    <div className="text-wrap" style={{ minWidth: 180 }}>
      <div className="d-flex justify-content-between align-items-center gap-2 mb-1">
        <span className="text-muted">Asking Price:</span>
        <span className="fw-medium">
          {formatBDT(stock?.asking_price) || "-"}
        </span>
      </div>
      <div className="d-flex justify-content-between align-items-center gap-2 mb-1">
        <span className="text-muted">Discount Price:</span>
        <span className="fw-medium text-primary">
          {formatBDT(stock?.discount_price) || "-"}
        </span>
      </div>
      {stock?.asking_price > stock?.discount_price && (
        <div className="d-flex justify-content-between align-items-center gap-2 mb-1">
          <span className="text-muted">You Save:</span>
          <span className="fw-medium text-success">
            {formatBDT(youSave)} ({youSavePercent}%)
          </span>
        </div>
      )}

      <div className="mt-1">
        <StockPricingUpdate
          stock={stock}
          btnId={`stock-list-edit-pricing-${stock.id || stock.stock_id}`}
        />
      </div>

      <div className="badge badge-soft-primary mt-1">
        <i className="fas fa-map-marker-alt me-1" style={{ fontSize: 7 }} />
        {stock?.showroom?.name ?? ""} - {stock?.showroom?.short_name ?? ""}
      </div>

      {!!stock.importer?.name && (
        <CanView access={[ACCESS.STOCK.VIEW_IMPORTER]}>
            <small className="text-muted d-block mt-1">
              {stock.importer?.name}
            </small>
        </CanView>
      )}
    </div>
  )
}

export default StockPriceCell
